import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private snackbar: MatSnackBar) { }

  showMessageSnackBar(
    msg: string = '',
    err: boolean = false,
    panelClass: Array<string> | null = null,
    horizontalPosition: any = 'center',
    verticalPosition: any = 'top',
    duration: number = 5
  ) {
    msg = this.getMsg(msg);

    if (msg) {
      this.snackbar.open(msg, 'OK', {
        panelClass: [
          ...(panelClass ? panelClass : err ? ['bg-danger'] : ['bg-success']),
          'text-white'
        ],
        horizontalPosition,
        verticalPosition,
        duration: duration * 1000
      });
    }
  }

  private getMsg(msg: string = '') {
    return (
      (this.isJson(msg) &&
        JSON.parse(msg) instanceof Array &&
        JSON.parse(msg)[0]) || msg);
  }

  isJson(data: any = '') {
    try {
      JSON.parse(data);
    } catch (e) {
      return false;
    }
    return true;
  }

  getFormatedDate(date: Date) {
    if (!date) {
      return null;
    }
    let day = ('0' + date.getDate()).slice(-2);
    let month = ('0' + (date.getMonth() + 1)).slice(-2);

    let year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  isValidEmail(email:string):boolean {
    if (!email || email == '') {
      return false;
    }
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }


  calculateGeoDistance(lat1, lon1, lat2, lon2, toMiles = false) {
    const R = 6371e3; // metres
    const Rad1 = this.degreesToRadians(lat1);
    const Rad2 = this.degreesToRadians(lat2);
    const Rad3 = this.degreesToRadians(lat2 - lat1);
    const Rad4 = this.degreesToRadians(lon2 - lon1);
    const a =
      Math.sin(Rad3 / 2) * Math.sin(Rad3 / 2) +
      Math.cos(Rad1) * Math.cos(Rad2) * Math.sin(Rad4 / 2) * Math.sin(Rad4 / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    if (toMiles)
      return this.getMiles(R * c);
    return R * c;
  }

  private degreesToRadians(degrees) {
    const pi = Math.PI;
    return degrees * (pi / 180);
  }
  private getMiles(num) {
    return num * 0.000621371192;
  }


}
